import { Grid } from '../grid';

// eslint-disable-next-line react/display-name
export const withContainer = (containerProps) => (Component) => (props) => (
  <Grid.Container {...containerProps}>
    <Component {...props} />
  </Grid.Container>
);
